import {
  FETCH_CHART_BOARD,
  FETCH_CHART_BOARD_SUCCESS,
  FETCH_CHART_BOARD_FAILURE,
} from "./constants";

export const fetchChartBoard = (payload) => ({
  type: FETCH_CHART_BOARD,
  payload, // { id: <location uuid>, from?: 'Y-MM-DD', to?: 'Y-MM-DD', residentId?: <resident uuid> }
});
export const fetchChartBoardSuccess = (payload) => ({
  type: FETCH_CHART_BOARD_SUCCESS,
  payload,
});
export const fetchChartBoardFailure = () => ({
  type: FETCH_CHART_BOARD_FAILURE,
});
